module.exports = {
  home: {
    nav1: "首页",
    nav2: "产品",
    nav3: "在线体验",
    nav4: "关于我们",
    nav5: "公司介绍",
    nav6: "加入我们",
    nav7: "联系我们",
    nav8: "关于",
    nav9: "服务",
    nav10: "隐私政策",
    nav11: "产品介绍",
    nav12: "关注我们",
    nav13: "关注公众号",
    nav14: "关注如见",
    title: "如见智能",
    title1: "AI形象生成领域的专家",
    btn: "立即体验",
    title2: "专业团队",
    title3: "成熟技术",
    title4: "全球资源保障",
    tips: "基于先进的人工智能技术，精准高效识别用户面部信息，如脸型、发色、长度、发量、性别、肤色等信息，结合目标形象，生成真实、有效的形象参考。",
    tips1: "如见智能的核心成员由来自纽约大学、波特兰州立大学、俄勒冈大学、普鲁德大学、俄亥俄州立大学、南洋理工大学的计算机视觉博士组成。",
    tips2: "团队在AI领域沉浸多年，在人工智能、计算机视觉和计算机图形学领域拥有完善的知识体系与成熟的技术，目前全面进行技术落地，相关产品已逐步投入市场。",
    tips3: "在全球多地拥有可靠的合作伙伴，如见期望与合作伙伴共同进步，一起用AI赋能，让生活更简单。",
    title5: "合作伙伴",
    title6: "中国科学院",
    tips4: "中国自然科学最高学术机构、科学技术最高咨询机构、自然科学与高技术综合研究发展中心。",
    tips5: "莫高丝路是将文化传媒与信息技术完美结合的创新型公司，独家全案承担了国家级项目“敦煌莫高窟保护工程”的创意策划、游客中心展陈形式与内容设计、游客线路设计与规划、莫高窟洞窟数字化、球幕电影和巨幕电影的节目承制及特种影院建设咨询等各项工作。成为“世界文化遗产保护与利用”经典案例。",
    title7: "发型生成",
    title8: "如见优势",
    title9: "北京莫高丝路文化发展有限公司",
    icp:"京ICP备2022018834号-1"
  },
  product: {
    ios:"苹果客户端下载",
    az:"安卓客户端下载",
    ios1:"苹果客户端下载",
    az1:"安卓客户端下载",
    title: "AI赋能，一键生成，",
    title6: "打造发型元宇宙时代",
    title1: "什么是Metastyle",
    tips: "为用户提供形象生成功能，用户通过上传形象→选择目标形象，即可一键生成，让用户一键百变，寻找适合自己的形象。",
    title2: "Metastyle的优势是什么",
    tips1: "基于先进的人工智能技术，精准高效识别用户面部信息，如脸型、发色、长度、发量、性别、肤色等信息，结合目标形象，生成真实、有效的形象参考。",
    title3: "上传形象",
    tips2: "通过相机或者相册",
    tips5: "上传您的形象",
    title4: "选择发型",
    tips3: "选择您喜欢的发型",
    title5: "生成形象",
    tips4: "根据您的形象和选择发型，",
    tips6: "为您生成新的形象"
  },
  experience: {
    title: "形象生成",
    title1: "基于先进的人工智能技术，精准高效识别用户面部信息，如脸型、发色、长度、发量、性别、肤色等信息，结合目标形象，生成真实、有效的形象参考。",
    title2: "功能体验",
    text: "将您的形象图片拖拽至此处或",
    text1:"点击上传",
    text2:"请上传您的正脸照片，五官清晰无遮挡",
    text3:"图片最高不超过5MB，支持jpg、png格式",
    text4:"在左侧上传您的形象",
    text5:"在右侧选择您想要的形象",
    text6:"点击下方按钮即可生成",
    text7:"生成形象",
    text8:"重新生成",
  },
  introduce: {
    title: "核心成员",
    title1: "企业目标",
    title2: "联系我们",
    name: "Charlie",
    name1: "Peng",
    name2: "李凡",
    name3: "Eric",
    name4: "Qiqi",
    name5: "Mike",
    nam6: "Ziwei",
    name7: "Steve",
    name8: "孙阳",
    text: "创始人",
    text1: "联合创始人",
    text2: "AI实验室负责人",
    text3: "首席科学家",
    text4: "首席产品经理",
    text5: '设计负责人',
    text6: "不忘初心",
    text7: "追求极致",
    text8: "客户第一",
    text9: "结果导向",
    text10: "勇于创新",
    text11: "谦虚务实",
    phone: "电话：400-000-000",
    email: "邮箱：schz@metastyle.art",
    address: "地址：北京市东城区淘汇新天4层106",
    content: "如见智能（北京如见智能科技有限公司）成立于 2022 年 2 月，正在利用人工智能和其他新兴技术的力量进行元宇宙的创造。我们为人工智能编辑、虚拟制作、视觉效果、3D重建和其他应用提供开创性的解决方案。我们的人工智能驱动平台简化和加速了产生突破性内容的过程，加强艺术家的能力，增强其创造力并提高故事性",
    content1: "人工智能编辑",
    content2: "虚拟制作",
    content3: "视觉效果",
    content4: "3D重建",
    content5: "如见智能由人工智能、计算机视觉和计算机图形学领域最聪明的头脑创建。我们的联合创始人包括多位来自纽约大学、波特兰州立大学、俄勒冈大学、普鲁德大学、俄亥俄州立大学、南洋理工大学的计算机视觉博士。",
    content6: "加入我们，共同成长"
  },
  join:{
      text:"收到需求后，我们会第一时间联系您",
      text1:"合作需求",
      text2:"姓名",
      text3:"请输入您的姓名",
      text4:"手机",
      text5:"请输入您的手机号",
      text6:"邮箱",
      text7:"请输入您的邮箱",
      text8:"公司",
      text9:"请输入您的公司/企业名称",
      text10:"需求说明",
      text11:"您可以简要描述您的需求，方便我们安排相关人员联系您",
      text12:"提交"
  }
};


// WEBPACK FOOTER //
// ./src/lang/language-zh.js